export default __webpack_public_path__ + "static/media/excelIcon.c7b66c3b.svg";